import styled from 'styled-components';

const Wrapper = styled.div<{ $open?: boolean }>`
  position: absolute;
  z-index: 999;
  bottom: 3rem;
  right: 0rem;
  width: 350px;
  border-radius: 0.5rem;
  overflow: hidden;
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  background: #ffffff;
  box-shadow:
    0px 0px 2px rgba(49, 73, 164, 0.14),
    0px 0px 3px rgba(49, 73, 164, 0.1),
    0px 12px 16px rgba(49, 73, 164, 0.08);
`;

const WidgetWrapper = ({ children, open }: { children: React.ReactNode; open: boolean }) => (
  <Wrapper $open={open}>{children}</Wrapper>
);

export default WidgetWrapper;
